import React, { Component } from 'react';
import styled from '@emotion/styled';
import { Layout } from 'layouts';
import theme from '@config/theme';
import {
  PageHeader,
  TechnologyPartners,
  BrandsWorkedWithUs,
} from '@components';
import Heading from '@components/pageHeading';
import PageNavigation from '@components/pageNavigation';
import pageContent from '@constants/portfolio';

import upkeepLogo from '@static/logo/upkeep-white.png';
import jasonsLogo from '@static/logo/jasons-logo.png';
import perckoLogo from '@static/logo/percko-logo.png';
import enjoyyeLogo from '@static/logo/enjoyye-logo.png';
import itSigmaLogo from '@static/logo/it-sigma-logo.png';
import awareiaLogo from '@static/logo/awareia.png';
import micmapsLogo from '@static/logo/mic-maps-logo.png';
import rollLogo from '@static/logo/roll-logo.png';
import trectoLogo from '@static/logo/tretto-logo.png';
import competishLogo from '@static/logo/competish-logo-white.png';

// import upkeepDesktopImage from '@static/portfolio/upkeep-bg.png';
import upkeepMobileImage from '@static/portfolio/upkeep-mockup-3.png';
import jasonsDesktopImage from '@static/portfolio/jason-lap.png';
import perckoDesktopImage from '@static/portfolio/percko-bg.png';
import enjoyyeDesktopImage from '@static/portfolio/enjoyye-lap.png';
import itSigmaMacImage from '@static/portfolio/itsigma-mac.png';
import awareiaDesktopImage from '@static/portfolio/awareia-bg.png';
import micmapsMobileImage from '@static/portfolio/micapp-iphone-mockup.png';
import rollMobileImage from '@static/portfolio/roll-app-screenshots.png';
import trectoMobileImage from '@static/portfolio/trecto-app-mockup.png';
import competishMobileImage from '@static/portfolio/competish-iphone-mockup-2.png';

const PortfolioRow = styled.div`
  display: flex;
  height: 720px;
  justify-content: space-between;
  flex-direction: ${props => (props.gravity == 'right' ? null : 'row-reverse')};

  @media (max-width: 991px) {
    flex-direction: column;
    height: auto;
  }
`;
const PortfolioContentCol = styled.div`
  display: flex;
  justify-content: ${props => (props.gravity == 'left' ? 'flex-end' : null)};
  background: ${props => props.theme.colors.white.lighter};

  @media (min-width: ${props => props.theme.breakpoints.m}) {
    padding: 0;
    flex: 1;
  }
`;
const PortfolioContentWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 600px;
  padding: 0 40px;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 991px) {
    max-width: none;
    text-align: center;
    margin: 50px 0 30px 0;
  }
`;
const PortfolioHeading = styled.h2`
  margin-bottom: 40px;
  width: 100%;
  position: relative;
  padding: 0;
  color: #3b3b3b;
  line-height: 1.2;
  font-family: Vidaloka, serif;

  @media (min-width: ${props => props.theme.breakpoints.s}) {
    text-align: left;
    font-size: 38px;
  }
  @media (max-width: 991px) {
    text-align: center;
  }
`;
const PortfolioHeadingLine = styled.div`
  position: absolute;
  width: 60px;
  height: 3px;
  display: block;
  right: 0;
  top: 50%;
  background: ${props => getPortfolioColor(props.portfolio)};

  @media (max-width: 991px) {
    display: none;
  }
`;
export const AppLogoWrapper = styled.div`
  margin-bottom: 35px;

  @media screen and (max-width: 767px) {
    .app-logo-container {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;
export const AppLogoContainer = styled.div`
  margin-bottom: 25px;
  display: flex;
  align-items: center;

  @media screen and (max-width: ${props => props.theme.breakpoints.m}) {
    justify-content: center;
  }
`;
export const AppLogo = styled.img`
  margin: 0;
  width: ${props => (props.size === 'small' ? '70px' : '200px')};
`;
export const AppTitle = styled.div`
  font-size: 50px;
  font-family: 'Montserrat';
  margin-left: 25px;
  font-weight: bold;
`;
export const AppHeading = styled.h3`
  font-size: 24px;
  line-height: 30px;
  color: ${props => props.theme.colors.black.dark};
  font-family: ${props => props.theme.fontFamily.heading};
`;
export const AppOverviewText = styled.p`
  font-family: 'Montserrat';
  font-size: 16px;
  line-height: 30px;
  color: ${props => props.theme.colors.black.dark};
  margin-right: 30px;

  @media screen and (max-width: 767px) {
    margin: 0 auto;
    padding: 0 !important;
    text-align: center;
  }
`;
const PortfolioImageCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${props => getPortfolioColor(props.portfolio)};

  @media (min-width: ${props => props.theme.breakpoints.m}) {
    padding: 0;
    flex: 1;
  }

  @media (max-width: 991px) {
    height: 500px;
  }
`;
const PortfolioImage = styled.img`
  width: ${props => getImageWidth(props.scale)};
  max-width: ${props => getImageMaxWidth(props.scale)};
  height: ${props => getImageHeight(props.scale)};
  max-height: ${props => getImageMaxHeight(props.scale)};
  margin-bottom: 0;
`;

class Portfolio extends Component {
  render() {
    const {
      title,
      headerImage,
      headingIcon,
      heading,
      overview,
      navigation,
    } = pageContent;
    return (
      <Layout>
        <PageHeader image={headerImage} title={title} icon={headingIcon} />

        <Heading title={heading} overview={overview} />

        <PortfolioRow gravity={'right'}>
          <PortfolioContentCol gravity={'left'}>
            <PortfolioContentWrapper>
              <PortfolioHeading>
                Our Latest Work
                <PortfolioHeadingLine portfolio={'upkeep'} />
              </PortfolioHeading>
              <AppLogoWrapper>
                <AppLogo src={upkeepLogo} />
              </AppLogoWrapper>
              <AppHeading>
                We engineered world's #1 mobile-first SaaS for Maintenance &amp;
                Facilities.
              </AppHeading>
              <AppOverviewText>
                Upkeep is a mobile-first CMMS software that makes technicians
                more agile and maintenance teams more productive. It is
                top-rated by CAPTERRA, Software Advice and G2 crowd and highly
                recommended by maintenance professionals. We unapologetically
                take pride in having crafted it with such excellence.
              </AppOverviewText>
            </PortfolioContentWrapper>
          </PortfolioContentCol>
          <PortfolioImageCol portfolio={'upkeep'}>
            <PortfolioImage src={upkeepMobileImage} scale={'fitY'} />
          </PortfolioImageCol>
        </PortfolioRow>
        <PortfolioRow gravity={'left'}>
          <PortfolioContentCol gravity={'right'}>
            <PortfolioContentWrapper>
              <PortfolioHeading>
                Our Latest Work
                <PortfolioHeadingLine portfolio={'jasons'} />
              </PortfolioHeading>
              <AppLogoWrapper>
                <AppLogo src={jasonsLogo} />
              </AppLogoWrapper>
              <AppHeading>
                We built Los Angeles Fastest Liquor Delivery Website
              </AppHeading>
              <AppOverviewText>
                Ordering wine and liquor in LA has never been this easy. Jason's
                Wine and Spirits provides you with unique wine and liquor
                selections to your doorstep. From all-day quick delivery to
                competitive pricing, scheduling gifts for loved ones, Jason's
                website has been driving great reviews for its fluidic
                functionality, simple and user-friendly UI.
              </AppOverviewText>
            </PortfolioContentWrapper>
          </PortfolioContentCol>
          <PortfolioImageCol portfolio={'jasons'}>
            <PortfolioImage src={jasonsDesktopImage} scale={'containX'} />
          </PortfolioImageCol>
        </PortfolioRow>
        <PortfolioRow gravity={'right'}>
          <PortfolioContentCol gravity={'left'}>
            <PortfolioContentWrapper>
              <PortfolioHeading>
                Our Latest Work
                <PortfolioHeadingLine portfolio={'percko'} />
              </PortfolioHeading>
              <AppLogoWrapper>
                <AppLogo src={perckoLogo} size={'small'} />
              </AppLogoWrapper>
              <AppHeading>
                eCommerce website for patented backache technology
              </AppHeading>
              <AppOverviewText>
                Our dedicated team built a clean yet very effective eCommerce
                website for team Percko. Not just eCommerce, the website has
                several informative sections as well. Started in 2014, they've
                had a simple goal from the beginning - to develop simple and
                innovative solutions that will help end the pain and suffering
                caused by back pain.
              </AppOverviewText>
            </PortfolioContentWrapper>
          </PortfolioContentCol>
          <PortfolioImageCol portfolio={'percko'}>
            <PortfolioImage src={perckoDesktopImage} scale={'containX'} />
          </PortfolioImageCol>
        </PortfolioRow>
        <PortfolioRow gravity={'left'}>
          <PortfolioContentCol gravity={'right'}>
            <PortfolioContentWrapper>
              <PortfolioHeading>
                Our Latest Work
                <PortfolioHeadingLine portfolio={'roll'} />
              </PortfolioHeading>
              <AppLogoContainer>
                <AppLogo src={rollLogo} size={'small'} />
                <AppTitle>Roll</AppTitle>
              </AppLogoContainer>
              <AppHeading>
                The holy grail for Jiu-Jitsu Social Networking app!
              </AppHeading>
              <AppOverviewText>
                Ever wanted to Roll Hard - Fight easy? Roll helps you with that.
                It's a Brazilian Jiu-Jitsu (BJJ) app which allows fighters and
                academies to manage their membership, track training stats and
                compare themselves with other fighters. It's more like your
                day-to-day dating app for lovers of this sport, but with less
                swiping, and more fighting.
              </AppOverviewText>
            </PortfolioContentWrapper>
          </PortfolioContentCol>
          <PortfolioImageCol portfolio={'roll'}>
            <PortfolioImage src={rollMobileImage} scale={'containY'} />
          </PortfolioImageCol>
        </PortfolioRow>
        <PortfolioRow gravity={'right'}>
          <PortfolioContentCol gravity={'left'}>
            <PortfolioContentWrapper>
              <PortfolioHeading>
                Our Latest Work
                <PortfolioHeadingLine portfolio={'micmaps'} />
              </PortfolioHeading>
              <AppLogoWrapper>
                <AppLogo src={micmapsLogo} />
              </AppLogoWrapper>
              <AppHeading>
                Fastest Growing App for Open Mics in the US.
              </AppHeading>
              <AppOverviewText>
                MicMaps brings stage at the tip of your finger! It is now the
                fastest growing and most trusted source to find nearby open
                mics, curated by time and location in the US. It is made for
                comics, by comics (not really, but okay).
              </AppOverviewText>
            </PortfolioContentWrapper>
          </PortfolioContentCol>
          <PortfolioImageCol portfolio={'rolmicmapsl'}>
            <PortfolioImage src={micmapsMobileImage} scale={'fitY'} />
          </PortfolioImageCol>
        </PortfolioRow>
        <PortfolioRow gravity={'left'}>
          <PortfolioContentCol gravity={'right'}>
            <PortfolioContentWrapper>
              <PortfolioHeading>
                Our Latest Work
                <PortfolioHeadingLine portfolio={'awareia'} />
              </PortfolioHeading>
              <AppLogoWrapper>
                <AppLogo src={awareiaLogo} />
              </AppLogoWrapper>
              <AppHeading>
                Intelligent Alert system for lost &amp; found powered by
                next-generation QR-code technology
              </AppHeading>
              <AppOverviewText>
                We helped them in the development of a simple yet effective
                solution to a common problem of misplacing valuable items in our
                busy daily lives with just 3 easy steps - buy &amp; attach
                Secure Quick Response Code® labels, lost item scanned at Awareia
                Hub and the subscriber is alerted &amp; reunited with the item.
                Bam, easy peasy.
              </AppOverviewText>
            </PortfolioContentWrapper>
          </PortfolioContentCol>
          <PortfolioImageCol portfolio={'awareia'}>
            <PortfolioImage src={awareiaDesktopImage} scale={'containX'} />
          </PortfolioImageCol>
        </PortfolioRow>
        <PortfolioRow gravity={'right'}>
          <PortfolioContentCol gravity={'left'}>
            <PortfolioContentWrapper>
              <PortfolioHeading>
                Our Latest Work
                <PortfolioHeadingLine portfolio={'enjoyye'} />
              </PortfolioHeading>
              <AppLogoWrapper>
                <AppLogo src={enjoyyeLogo} />
              </AppLogoWrapper>
              <AppHeading>
              First social jewelry shopping community.
              </AppHeading>
              <AppOverviewText>
              The aim was to create one of the first social shopping community of its kind where jewelry lovers can enjoy discovering and shopping for the latest socially curated jewelry trends around the world while giving someone else in need joy via charity. enJOYYE was also envisioned as a platform for small talented designers who have individual stores all across the US and the world to showcase their jewelry products online and enlist their store for free.
              </AppOverviewText>
            </PortfolioContentWrapper>
          </PortfolioContentCol>
          <PortfolioImageCol portfolio={'enjoyye'}>
            <PortfolioImage src={enjoyyeDesktopImage} scale={'containX'} />
          </PortfolioImageCol>
        </PortfolioRow>
        <PortfolioRow gravity={'left'}>
          <PortfolioContentCol gravity={'right'}>
            <PortfolioContentWrapper>
              <PortfolioHeading>
                Our Latest Work
                <PortfolioHeadingLine portfolio={'trecto'} />
              </PortfolioHeading>
              <AppLogoContainer>
                <AppLogo src={trectoLogo} size={'small'} />
                <AppTitle>Trecto</AppTitle>
              </AppLogoContainer>
              <AppHeading>
                Highly recommened app for Business networking.
              </AppHeading>
              <AppOverviewText>
                Trecto is a networking app that helps you do better business
                with personal connections, track your calls, remember
                conversations and download reports. It is known for its
                straightforward functionality and seamless design. It is highly
                recommended for its features with a 5-star rating on the App
                Store.
              </AppOverviewText>
            </PortfolioContentWrapper>
          </PortfolioContentCol>
          <PortfolioImageCol portfolio={'trecto'}>
            <PortfolioImage src={trectoMobileImage} scale={'containY'} />
          </PortfolioImageCol>
        </PortfolioRow>
        <PortfolioRow gravity={'right'}>
          <PortfolioContentCol gravity={'left'}>
            <PortfolioContentWrapper>
              <PortfolioHeading>
                Our Latest Work
                <PortfolioHeadingLine portfolio={'itSigma'} />
              </PortfolioHeading>
              <AppLogoWrapper>
                <AppLogo src={itSigmaLogo} />
              </AppLogoWrapper>
              <AppHeading>
                We helped in IT process improvements for a Fortune 500 company.
              </AppHeading>
              <AppOverviewText>
                Highly functioning organizations are built on a foundation of
                solid repeatable quality processes. From system implementation
                to program consulting, process design to system administration,
                we helped ITSigma provide these services to top brands around
                the globe.
              </AppOverviewText>
            </PortfolioContentWrapper>
          </PortfolioContentCol>
          <PortfolioImageCol portfolio={'itSigma'}>
            <PortfolioImage src={itSigmaMacImage} scale={'containX'} />
          </PortfolioImageCol>
        </PortfolioRow>
        <PortfolioRow gravity={'left'}>
          <PortfolioContentCol gravity={'right'}>
            <PortfolioContentWrapper>
              <PortfolioHeading>
                Our Latest Work
                <PortfolioHeadingLine portfolio={'competish'} />
              </PortfolioHeading>
              <AppLogoWrapper>
                <AppLogo src={competishLogo} />
              </AppLogoWrapper>
              <AppHeading>
                1.8K+ reviews for this competent Fitness app.
              </AppHeading>
              <AppOverviewText>
                Competish is a fitness app, it also is a social app, and a
                money-making app...and...an app you'd never want to delete. It
                helps people achieve their weight-loss goals using the two most
                potent motivators: social network and money. It's a 4.4-star
                rated app with 1.8K+ positive reviews.
              </AppOverviewText>
            </PortfolioContentWrapper>
          </PortfolioContentCol>
          <PortfolioImageCol portfolio={'competish'}>
            <PortfolioImage src={competishMobileImage} scale={'fitY'} />
          </PortfolioImageCol>
        </PortfolioRow>

        <PageNavigation prev={navigation.prev} next={navigation.next} />

        <TechnologyPartners />

        <BrandsWorkedWithUs />
      </Layout>
    );
  }
}

const getPortfolioColor = portfolioKey => {
  switch (portfolioKey) {
    case 'upkeep':
      return '#fc2c41';
    case 'roll':
      return 'rgba(62, 85, 242, 1)';
    case 'jasons':
      return '#272727';
    case 'trecto':
      return 'rgba(149, 43, 153, 1)';
    case 'competish':
      return 'rgba(51, 56, 77, 1)';
    case 'micmaps':
      return 'rgba(15, 236, 187, 1)';
    case 'percko':
      return '#777777';
    case 'enjoyye':
      return '#a8208b';
    case 'itSigma':
      return '#00bfd3';
    case 'awareia':
      return '#03a9f4';
    default:
      return theme.colors.primary.base;
  }
};

const getImageWidth = scalType => {
  switch (scalType) {
    case 'containX':
      return '90%';
    case 'fitX':
      return '100%';
    case 'containY':
    case 'fitY':
      return 'auto';
    default:
      return '100%';
  }
};

const getImageMaxWidth = scalType => {
  switch (scalType) {
    case 'containX':
      return '700px';
    default:
      return null;
  }
};

const getImageHeight = scalType => {
  switch (scalType) {
    case 'containY':
      return '80%';
    case 'fitY':
      return '100%';
    case 'containX':
    case 'fiX':
      return 'auto';
    default:
      return 'auto';
  }
};

const getImageMaxHeight = scalType => {
  switch (scalType) {
    case 'containY':
      return '460px';
      return null;
  }
};

export default Portfolio;
